<div #thumbnailRef class="keen-slider thumbnails carousel thumbs type-two">
  <ng-container *ngFor="let item of images; trackBy: trackByItem">
    <ng-container *ngIf="item">
      <div class="keen-slider__slide">
        <ng-container *ngIf="parent">
          <img loadling="lazy" [src]="item" [alt]="genericAlt" width="100%" height="100%" />
        </ng-container>
        <ng-container *ngIf="gallery">
          <a [routerLink]="[isVideo == true ? '/videos' : '/albums', item?.id]"><img loading="lazy" [src]="item.data" onError="this.src='/assets/images/no-image.webP'" width="100%" height="100%" /></a>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
